var generateStyle = function generateStyle(componentTheme) {
  return {
    wrapper: {
      display: 'flex',
      flexDirection: 'column'
    },
    inputsWrapper: {
      display: 'flex'
    },
    timeInputWrapper: {
      display: 'inline-flex',
      padding: "0 ".concat(componentTheme.timeInputWrapperPadding)
    },
    timeInfo: {
      padding: "".concat(componentTheme.timeInfoPadding, " 0")
    }
  };
};
export default generateStyle;